/**
 * Identité de marque.
 *
 * Tout ce qui est visible par l'utilisateur et propre à la marque vit ici :
 * changer de nom commercial ou de signature ne demande de toucher qu'à ce
 * fichier, jamais aux écrans.
 */
export const BRAND = {
  /** Nom commercial, tel qu'il apparaît partout. */
  name: 'BD Innovation',
  /** Signature courte, sous le logo. */
  tagline: 'La solution pour votre véhicule',
  /** Accroche principale de la page d'accueil, en deux morceaux. */
  headline: 'Loue la voiture qu’il te faut,',
  headlineAccent: 'simplement.',
  /** Phrase de présentation, reprise dans les métadonnées. */
  description:
    'BD Innovation Auto Cars : louez, achetez et vendez votre véhicule à Abidjan. Agences vérifiées, annonces contrôlées, sans commission.',
  /** Marché de lancement, affiché au-dessus de l'accroche. */
  market: 'Abidjan · Côte d’Ivoire',
  /** Couleur de marque, pour les métadonnées du navigateur. */
  themeColor: '#a82991',
} as const;

/**
 * Les trois accroches de l'accueil, qui défilent.
 *
 * L'accueil ne parlait que de location : un visiteur venu acheter ou vendre
 * n'avait aucune raison de comprendre que la plateforme le permet aussi. Trois
 * accroches qui se succèdent le disent sans rien ajouter à la page.
 *
 * L'ordre n'est pas neutre : la location reste la première offre, elle passe
 * en tête et c'est elle qu'on voit à l'arrivée.
 */
export const BRAND_SLIDES = [
  {
    key: 'louer',
    title: 'Loue la voiture qu’il te faut,',
    accent: 'simplement.',
    text: 'Des agences vérifiées à Abidjan. Prix ferme, paiement en espèces à la remise.',
    cta: { label: 'Chercher un véhicule', to: '/recherche' },
  },
  {
    key: 'acheter',
    title: 'Achète la voiture qu’il te faut,',
    accent: 'simplement.',
    text: 'Des annonces vérifiées avant publication. Vous traitez directement avec le vendeur.',
    cta: { label: 'Voir les voitures à vendre', to: '/voitures-a-vendre' },
  },
  {
    key: 'vendre',
    title: 'Vends ta voiture,',
    accent: 'simplement.',
    text: 'Publiez gratuitement. Nous vérifions, les acheteurs vous écrivent directement.',
    cta: { label: 'Publier mon annonce', to: '/vendre-ma-voiture' },
  },
] as const;

/**
 * Avantages mis en avant sur la page d'accueil.
 * `icon` correspond à une clé du composant BrandIcon.
 */
export const BRAND_HIGHLIGHTS = [
  { icon: 'calendar', label: 'Réservation rapide' },
  { icon: 'car', label: 'Large choix de véhicules' },
  { icon: 'shield', label: 'Paiement encadré' },
  { icon: 'support', label: 'Support client 7j/7' },
  { icon: 'tag', label: 'Meilleurs tarifs' },
  { icon: 'pin', label: 'Disponible partout' },
] as const;

/** Les trois temps du parcours, repris de l'identité. */
export const BRAND_STEPS = [
  {
    icon: 'phone',
    number: '1',
    title: 'CHOISIS',
    text: 'le véhicule qui te convient, parmi les offres des agences vérifiées.',
  },
  {
    icon: 'calendar',
    number: '2',
    title: 'RÉSERVE',
    text: 'en quelques secondes, avec un prix ferme et un contrat clair.',
  },
  {
    icon: 'key',
    number: '3',
    title: 'ROULE',
    text: 'et profite de ton GBA CHAP, état des lieux photo à l’appui.',
  },
] as const;
